import { lazy as lazyLoad } from 'react';

import { route } from '../profile/constants';

import type { RouteDefinition } from '../../route';

const lazy = {
    EditPersonalInformationPage: lazyLoad(async () => {
        const { EditPersonalInformation } = await import('./EditPersonalInformation');

        return { default: EditPersonalInformation };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.edit-personal-info.title',
        page: lazy.EditPersonalInformationPage,
        path: route.patterns.individualUser.personalInformation.edit,
    },
];
